import { useFeatureFlag } from "common/feature_gating";
import {
  IA_NAV,
  ORGANIZATION_BRAND_NAME,
  PROOF_TRANSACTIONS,
  SENDER_ROLE_PHASE_3,
  USER_DASHBOARD_RESKIN,
} from "constants/feature_gates";
import { isNotaryNST } from "common/notary/capacity";
import { includesOrgAdminRole } from "util/organization";
import { useViewer } from "util/viewer_wrapper";

export function useProofDefendUpsell(
  organization?: { id: string; proofDefend: boolean } | null,
): boolean {
  const { viewer } = useViewer();
  const userRoles = viewer.user?.roles;
  return (
    useFeatureFlag("proof-defend-upsell") &&
    Boolean(organization && !organization.proofDefend) &&
    includesOrgAdminRole(userRoles ?? [])
  );
}

export function useProofDefend(
  organization?: { id: string; proofDefend: boolean } | null,
): boolean {
  return Boolean(organization?.proofDefend);
}

// Remove in REAL-8187
export function useIAnav(): boolean {
  return useFeatureFlag(IA_NAV);
}

export const useProofRebrand = () => {
  // flag exists in launch darkly for both signer and business
  // https://notarize.atlassian.net/wiki/spaces/MRT/pages/3219095860/Rebrand+branching+logic
  return useFeatureFlag("proof-rebrand", false);
};

export function useCompanyName(): "Proof" | "Notarize" {
  return useProofRebrand() ? "Proof" : "Notarize";
}

export function useProofTransactionsEnabled(
  notaryProfile: Parameters<typeof isNotaryNST>[0],
): boolean {
  return useFeatureFlag(PROOF_TRANSACTIONS) && !isNotaryNST(notaryProfile);
}

export function useOrganizationBrandName(): boolean {
  return useFeatureFlag(ORGANIZATION_BRAND_NAME);
}

export function useSenderRolePhase3(): boolean {
  return useFeatureFlag(SENDER_ROLE_PHASE_3);
}

export function useUserDashboardReskin(): boolean {
  return useFeatureFlag(USER_DASHBOARD_RESKIN);
}

export function useOdnRemoteWitness(): boolean {
  return useFeatureFlag("odn-remote-witness-enabled");
}

export function useOdnRemoteWitnessCredViewer(): boolean {
  return useFeatureFlag("new-credential-viewer-for-odn-witness-enabled");
}

export function isFeatureEnabled(
  organization: { featureFlags: { key: string; value: string }[] },
  flag: string,
): boolean {
  return organization.featureFlags.find((f) => f.key === flag)?.value === "true";
}
